/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useAzureProvider } from 'src/azure/context';
import { useAutomationRuleFormProvider } from 'src/pages/automation-rule/form';
import { actionTypes } from 'src/pages/automation-rule/form/actions';
import { initialEditWorkItem } from 'src/pages/automation-rule/form/actions/edit-work-item/use-edit-work-item';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import useFieldValueChanged, { initialFieldValueChange } from 'src/pages/automation-rule/form/trigger/field-value-changed-form/use-field-value-changed';
import { triggerTypes, useAutomationRuleTrigger } from 'src/pages/automation-rule/form/trigger/use-trigger';
import { randomStringGenerator } from 'src/pages/automation-rule/form/utils/random-string-generator';

export function useApplyChangesForAllChildrenWhenParentIterationIsUpdated() {
	const {applicationContext} = useAzureProvider();

	const { setTitle } = useAutomationRuleFormProvider();
	const { setTrigger, setTriggerData } = useAutomationRuleTrigger();
	const { setActions } = useAutomationRuleActions();
	const { getValueOptions } = useFieldValueChanged();

	const applyChangesForAllChildrenWhenParentIterationIsUpdated = useCallback(async() => {
		setTitle('When the parent’s Iteration is updated, apply the change to all child work items');
		setTrigger(triggerTypes.fieldValueIsChanged);

		setTriggerData({
			workItemTransitions: null,
			workItemIsAssignedTo: null,
			checklistTrigger: null,
			fieldValueChange: {
				...initialFieldValueChange,
				fieldNameQuery: null,
				fieldName: 'System.IterationPath',
				selectedOptions: 'System.IterationPath',
				fieldOptions: await getValueOptions({projectId: applicationContext.projectId}),
				loading: false,
			},
		});
		setActions([
			{
				id: randomStringGenerator(),
				action: actionTypes.editWorkItem,
				editWorkItem: {
					...initialEditWorkItem,
					relationship: 'children-work-items',
					workItemField: 'System.IterationPath',
					fieldActionValue: 'copy-field-value',
					copyFieldValue: 'System.IterationPath',
				},
				addCommentToWorkItem: null,
				sendNotificationToSlack: null,
				sendEmailNotification: null,
				sendTeamsNotification: null,
				createdAt: new Date(),
			},
		]);
	}, []);

	return {
		applyChangesForAllChildrenWhenParentIterationIsUpdated,
	};
}